export default {
  order_methods: {
    delivery: 'Toimitus',
    pickup: 'Nouto',
    room_service: 'Paikan päällä',
    table_service: 'Paikan päällä',
  },
  time: '{{time}} min',
  asap: 'Heti',
  unavailable: 'Ei saatavilla',
  ready_in: 'Valmiina ',
  buttons: {
    change: 'Muuta',
    see_hours: 'Katso aukioloajat',
    change_location: 'Vaihda sijaintia',
    change_time: 'Vaihda aikaa',
  },
};
